import { render, staticRenderFns } from "./LandingConfig.vue?vue&type=template&id=357acb01"
import script from "./LandingConfig.vue?vue&type=script&lang=js"
export * from "./LandingConfig.vue?vue&type=script&lang=js"
import style0 from "./LandingConfig.vue?vue&type=style&index=0&id=357acb01&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('357acb01')) {
      api.createRecord('357acb01', component.options)
    } else {
      api.reload('357acb01', component.options)
    }
    module.hot.accept("./LandingConfig.vue?vue&type=template&id=357acb01", function () {
      api.rerender('357acb01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/dashboard/components/LandingConfig.vue"
export default component.exports